(function () {
  'use strict';

  function initDeptMenu(dm) {
    if (dm.__sfdm) return; dm.__sfdm = true;
    var summary = dm.querySelector('summary');
    var li = dm.parentElement;
    var tOpen = null, tClose = null;
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    function setOpen(v) {
      if (v) dm.setAttribute('open', ''); else dm.removeAttribute('open');
      summary.setAttribute('aria-expanded', v ? 'true' : 'false');
    }
    function activate(i) {
      dm.querySelectorAll('[data-sf-dm-dept]').forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-sf-dm-dept') === i); });
      dm.querySelectorAll('[data-sf-dm-pane]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-sf-dm-pane') === i); });
    }
    summary.setAttribute('aria-expanded', 'false');
    if (canHover) {
      li.addEventListener('mouseenter', function () { clearTimeout(tClose); tOpen = setTimeout(function () { setOpen(true); }, 90); });
      li.addEventListener('mouseleave', function () { clearTimeout(tOpen); tClose = setTimeout(function () { setOpen(false); }, 160); });
      summary.addEventListener('click', function (e) { if (dm.hasAttribute('open')) { e.preventDefault(); } });
    }
    dm.querySelectorAll('[data-sf-dm-dept]').forEach(function (a) {
      var i = a.getAttribute('data-sf-dm-dept');
      a.addEventListener('mouseenter', function () { activate(i); });
      a.addEventListener('focus', function () { activate(i); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && dm.hasAttribute('open')) { setOpen(false); summary.focus(); } });
    document.addEventListener('click', function (e) { if (dm.hasAttribute('open') && !dm.contains(e.target)) setOpen(false); });
  }

  function initScroller(root) {
    if (root.__sfsc) return; root.__sfsc = true;
    var sc = root.querySelector('[data-sf-scroller]'); if (!sc) return;
    var btns = root.querySelectorAll('[data-sf-scroll]');
    function state() {
      var max = sc.scrollWidth - sc.clientWidth - 2;
      btns.forEach(function (b) {
        var dir = +b.getAttribute('data-sf-scroll');
        b.disabled = max <= 0 || (dir < 0 ? sc.scrollLeft <= 2 : sc.scrollLeft >= max);
      });
      root.classList.toggle('is-scrollable', max > 0);
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        sc.scrollBy({ left: +b.getAttribute('data-sf-scroll') * Math.max(240, sc.clientWidth * 0.85), behavior: 'smooth' });
      });
    });
    sc.addEventListener('scroll', function () { window.requestAnimationFrame(state); }, { passive: true });
    window.addEventListener('resize', state);
    state();
  }

  var RV_KEY = 'sfRecentV1';
  function rvRead() { try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]') || []; } catch (e) { return []; } }
  function rvRecord() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/); if (!m) return;
    var h = decodeURIComponent(m[1]);
    var list = rvRead().filter(function (x) { return x !== h; });
    list.unshift(h);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
  }
  function money(cents, fmt) {
    function fmtNum(n, dec, th, ds) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.length > 1 ? parts[0] + ds + parts[1] : parts[0];
    }
    fmt = fmt || '{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return fmtNum(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmtNum(cents, 2, ' ', ',');
        default: return fmtNum(cents, 2, ',', '.');
      }
    });
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function rvRender(sec) {
    if (sec.__sfrv) return; sec.__sfrv = true;
    var cur = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    var list = rvRead().filter(function (h) { return h !== cur; }).slice(0, 10);
    if (list.length < 2) return;
    var root = (sec.getAttribute('data-root') || '/').replace(/\/?$/, '/');
    var fmt = sec.getAttribute('data-money');
    Promise.all(list.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      ps = ps.filter(function (p) { return p && p.url; });
      if (ps.length < 2) return;
      var html = ps.map(function (p) {
        var img = p.featured_image ? (p.featured_image.indexOf('?') > -1 ? p.featured_image + '&width=400' : p.featured_image + '?width=400') : '';
        var from = p.price_varies ? 'ab ' : '';
        var cmp = (!p.price_varies && p.compare_at_price > p.price) ? '<s>' + esc(money(p.compare_at_price, fmt)) + '</s>' : '';
        return '<div class="sf-rail__item sf-rv__item"><a href="' + esc(p.url) + '" class="sf-mc">' +
          '<span class="sf-mc__media">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" width="200" height="200" loading="lazy">' : '') + '</span>' +
          (p.vendor ? '<span class="sf-mc__vendor">' + esc(p.vendor) + '</span>' : '') +
          '<span class="sf-mc__title">' + esc(p.title) + '</span>' +
          '<span class="sf-mc__price">' + from + '<strong>' + esc(money(p.price_min != null ? p.price_min : p.price, fmt)) + '</strong>' + cmp + '</span></a></div>';
      }).join('');
      sec.querySelector('.sf-rv__track').innerHTML = html;
      sec.hidden = false;
      sec.__sfsc = false; initScroller(sec);
    });
  }

  function init() {
    rvRecord();
    document.querySelectorAll('[data-sf-rv]').forEach(rvRender);
    document.querySelectorAll('[data-sf-dm]').forEach(initDeptMenu);
    document.querySelectorAll('.sf-chips__track').forEach(function (t) {
      var a = t.querySelector('.sf-chip.is-active');
      if (a && t.scrollWidth > t.clientWidth) t.scrollLeft = Math.max(0, a.offsetLeft - (t.clientWidth - a.offsetWidth) / 2);
    });
    document.querySelectorAll('[data-sf-scroller]').forEach(function (sc) {
      var sec = sc.closest('section') || sc.parentElement;
      if (!sec.hasAttribute('data-sf-rv')) initScroller(sec);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
